

































































































































import { Component, Vue } from 'vue-property-decorator';
import OtDatePicker, { DatepickerTypeEnum } from '@/components/global/ot-date-picker.vue';
import OtTextField from '@/components/global/ot-text-field.vue';

@Component({
  components: {
    OtDatePicker,
    OtTextField,
  },
})
export default class OtDatePickerWrapper extends Vue {
  // * PROPS

  // * DATA
  private singleDateValue = '';
  private singleDateValueRequired = '';
  private singleDateValueLight = '';
  private dateRangeValues: string[] = [];
  private multipleDateValues: string[] = [];
  private singleType = DatepickerTypeEnum.Single;
  private rangeType = DatepickerTypeEnum.Range;
  private multipleType = DatepickerTypeEnum.Multiple;

  private nativeDateInput: string | null = null;
  private vuetifyTextFieldAsDateInput: string | null = null;
  private otTextFieldAsDateInput: string | null = null;

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
